/**
 * lockoutPass.js — the WORK PASS (Matt, 2026-10-16: "I tried to open the work for Sara to review it,
 * but when I opened the pre-design report to QC, the lockout brought up the triage message on the QC
 * tool so I couldn't actually QC in the app").
 *
 * When a lockout card opens a piece of work (EntityPeekModal opened while a daily lockout is up), the
 * person is DOING the triage, not dodging it. So the tool windows they open from there (AlderQC,
 * document markup, AlderCAD, AlderSPEC, Sketch — LockoutHost's TOOL_PATHS) skip the lockouts for a
 * while. Bounded both ways (the bounded-escape-hatch rule):
 *   - time: the pass lasts PASS_MS from the last time work was opened from a lockout;
 *   - scope: it exempts tool windows only. The outline still shows every lockout, so nothing in
 *     Triage is skipped; it is only ANSWERED from the main window, after the work is done.
 * Stored in localStorage so a new tab sees it. Never set by anything but a blocking lockout.
 */
const KEY = 'aj-lockout-work-pass'
const PASS_MS = 2 * 60 * 60 * 1000

// Which lockouts are up in THIS window, from the events each gate already fires.
const up = { time: false, report: false, triage: false }
if (typeof window !== 'undefined') {
  window.addEventListener('time-gate-blocking-changed', e => { up.time = !!(e.detail && e.detail.blocking) })
  window.addEventListener('report-gate-blocking-changed', e => { up.report = !!(e.detail && e.detail.blocking) })
  window.addEventListener('triage-gate-blocking-changed', e => { up.triage = !!(e.detail && e.detail.blocking) })
}
export function lockoutUp() { return up.time || up.report || up.triage }

/** Called when work is opened from a lockout card. No-op unless a lockout is actually up. */
export function issueWorkPass() {
  if (!lockoutUp()) return
  try { localStorage.setItem(KEY, String(Date.now() + PASS_MS)) } catch { /* no pass without storage: tools stay locked */ }
}
/** Minutes left on the pass, or 0. */
export function workPassMinutes() {
  try {
    const until = Number(localStorage.getItem(KEY) || 0)
    return until > Date.now() ? Math.ceil((until - Date.now()) / 60000) : 0
  } catch { return 0 }
}
